const menuItems = [
  { label: "Home", url: "/" },
  { label: "Services", url: "/services"},
  { label: "Goods", url: "/goods"},
  { label: "Jobs", url: "/career"},
  { label: "About", url: "/about-us" },
  { label: "Contact", url: "/contact-us"},
];

export default menuItems;
